import React from "react";
import { Link } from "react-router-dom";
import * as DateHelper from "../utils/date.formatter";
import { REACT_APP_MODE } from "../config";
import { Translation } from "react-i18next";
import i18n from "../languages/lang.js";

export default props => {
  const mode = props.mode;
  if (!props.data || props.data.length === 0) {
    return <div className="empty-data">{i18n.t("system.empty_data")}</div>;
  }
  return (
    <Translation>
      {t => (
        <table className="table-list-simple">
          <thead>
            <tr>
              <th>{t("common.name")}</th>
              <th>{t("common.site")}</th>
              <th>{t("common.status")}</th>
              <th>{t("common.start_date")}</th>
              <th>{t("common.end_date")}</th>
              <th className="last">{t("common.created")}</th>
            </tr>
          </thead>
          <tbody>
            {props.data.map(item => {
              return (
                <tr key={item.key}>
                  <td className="important">
                    <Link to={`/campaigns/${item.key}`}>{item.name}</Link>
                  </td>
                  <td>
                    <Link to={`/campaigns/${item.key}`}>{item.site_name}</Link>
                  </td>
                  <td>
                    <Link
                      className={`status-${item.status.toLowerCase()}`}
                      to={`/campaigns/${item.key}`}
                    >
                      {t("campaign.status_" + item.status.toLowerCase())}
                    </Link>
                  </td>
                  <td>
                    <Link to={`/campaigns/${item.key}`}>
                      {item.start_date
                        ? DateHelper.shortenDate(item.start_date)
                        : ""}
                    </Link>
                  </td>
                  <td>
                    <Link to={`/campaigns/${item.key}`}>
                      {item.end_date
                        ? DateHelper.shortenDate(item.end_date)
                        : ""}
                    </Link>
                  </td>
                  <td className="last">
                    <Link to={`/campaigns/${item.key}`}>
                      {DateHelper.toLocalString(item.created)}
                    </Link>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      )}
    </Translation>
  );
};
